import React from 'react';
import { Button, Col, Form, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { Formik } from 'formik';
import * as Yup from 'yup';

import {
  FileUploadField,
  FileUploadFileTooBig,
} from '@components/Forms/CustomFields';
import { ticketApi } from '@reducers/tickets/tickets';

const CreateTicketCommentForm = () => {
  const [createQuery, createResult] = ticketApi.usePostCommentMutation();
  const { ticketID } = useParams();
  const schema = Yup.object({
    comment: Yup.string().required(),
    attachments: FileUploadFileTooBig(),
  });
  const initialValues = {
    comment: '',
    attachments: [],
  };
  const onSubmit = async (values) => {
    createQuery({ ticketID, data: values });
  };
  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="form.ControlComment">
                <Form.Control
                  type="text"
                  placeholder="Description"
                  name="comment"
                  as="textarea"
                  rows={3}
                  value={values.comment}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isValid={touched.comment && !errors.comment}
                  isInvalid={touched.comment && errors.comment}
                />
              </Form.Group>
              <FormGroup controlId="form.ControlAttachments">
                <FormLabel>Attachments:</FormLabel>
                <FileUploadField name="attachments" multiple />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="text-start mt-3" md={12}>
              <Button
                size="sm"
                variant="didxl"
                onClick={handleSubmit}
                disabled={createResult.isLoading}
              >
                Post
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};
export default CreateTicketCommentForm;
